import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFundsExchangeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2116 16.92H15.7208V19.4062L21.5625 14.3897L15.7208 9.37238V11.8594H7.28001V14.3456L1.4375 9.32904L7.28001 4.3125V6.79871H12.7884",
		stroke: "#00666D",
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFundsExchangeIcon;
